import { C as CosmosIconCheckmark$1, d as defineCustomElement$1 } from './p-G9l7h4A8.js';

const CosmosIconCheckmark = CosmosIconCheckmark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCheckmark, defineCustomElement };
